import { DistributionType, EstateType } from '@aviv-search/types';
export var TrackingMediumName;
(function (TrackingMediumName) {
    TrackingMediumName["CARD_MAP"] = "classified_search_results_map_classified_classified_detail";
    TrackingMediumName["CARD_MAP_LIST"] = "classified_search_results_map_list_classified_classified_detail";
    TrackingMediumName["CARD_SERP"] = "classified_search_results_classified_classified_detail";
})(TrackingMediumName || (TrackingMediumName = {}));
export const mapListButtonTrackingMedium = {
    list: 'classifed_search_results_map_switch_button_to_classified_search_results',
    map: 'classifed_search_results_switch_button_to_classified_search_results_map',
};
export const getMediumInQueryString = (qs) => {
    const searchParams = new URLSearchParams(qs);
    return searchParams.get('m');
};
export const infosSerpPageView = {
    [DistributionType.RENT]: {
        title: 'classified_search_results_rent',
        distributionTypeGlobal: '1',
    },
    [DistributionType.BUY]: {
        title: 'classified_search_results_buy',
        distributionTypeGlobal: '2',
    },
    [DistributionType.BUY_AUCTION]: {
        title: 'classified_search_results_buy',
        distributionTypeGlobal: '2',
    },
    [DistributionType.COMPULSORY_AUCTION]: {
        title: 'classified_search_results_buy',
        distributionTypeGlobal: '2',
    },
};
export const infosMapPageView = {
    [DistributionType.RENT]: {
        title: 'classified_search_results_map_rent',
        distributionTypeGlobal: '1',
    },
    [DistributionType.BUY]: {
        title: 'classified_search_results_map_buy',
        distributionTypeGlobal: '2',
    },
    [DistributionType.BUY_AUCTION]: {
        title: 'classified_search_results_map_buy',
        distributionTypeGlobal: '2',
    },
    [DistributionType.COMPULSORY_AUCTION]: {
        title: 'classified_search_results_map_buy',
        distributionTypeGlobal: '2',
    },
};
export const infosEstateType = {
    [EstateType.AGRICULTURE_FORESTRY]: '',
    [EstateType.APARTMENT]: 'av_2',
    [EstateType.GASTRONOMY_HOTEL]: '',
    [EstateType.HOUSE]: 'av_5',
    [EstateType.MISCELLANEOUS]: '',
    [EstateType.OFFICE]: 'av_7',
    [EstateType.PARKING]: 'av_8',
    [EstateType.PLOT]: 'av_9',
    [EstateType.STORAGE_PRODUCTION]: '',
    [EstateType.TRADING]: 'av_13',
    [EstateType.SENIOR]: '',
};
export const infosOrder = {
    DateDesc: 'date',
    Default: 'relevance',
    PriceAsc: 'price_low_to_high',
    PriceDesc: 'price_high_to_low',
    // TODO Fix the key when the sorting will be ready
    postal_code: 'postal_ code',
    rooms: 'rooms',
    surface_largest_to_smallest: 'surface_largest_to_smallest',
    surface_smallest_to_largest: 'surface_smallest_to_largest',
    recommendation: 'recommendation',
};
